import { createAsyncStore } from "common/axios/asyncModel";
import { MeetingRepository } from "repository/meetingRepository";

// 모임 목록 조회
const meetingList = createAsyncStore();
const onGetMeetingList = (params?: { category?: string; status?: string; keyword?: string; page?: number; pageSize?: number }) => {
    // params가 undefined일 경우 빈 객체로 초기화
    const requestParams = params || {};
    meetingList.onGetAll(() => MeetingRepository.onGetMyMeetings(requestParams));
}

// 모임 상세 조회
const meetingDetail = createAsyncStore();
const onGetMeetingDetail = (meetingId: string) => {
    meetingDetail.onGetAll(() => MeetingRepository.onGetMeetingDetail(meetingId));
}

// 모임 생성
const createMeeting = createAsyncStore();
const onCreateMeeting = (params: any) => {
    createMeeting.onGetAll(() => MeetingRepository.onPostCreateMeeting(params));
}

// 모임 수정
const updateMeeting = createAsyncStore();
const onUpdateMeeting = (meetingId: string, params: any) => {
    updateMeeting.onGetAll(() => MeetingRepository.onPutUpdateMeeting(meetingId, params));
}

// 모임 삭제
const deleteMeeting = createAsyncStore();
const onDeleteMeeting = (meetingId: string) => {
    deleteMeeting.onGetAll(() => MeetingRepository.onDeleteMeeting(meetingId));
}

// 모임 초대
const inviteMeeting = createAsyncStore();
const onInviteMeeting = (meetingId: string, params: any) => {
    inviteMeeting.onGetAll(() => MeetingRepository.onPostInviteToMeeting(meetingId, params));
}

// 모임 참여
const joinMeeting = createAsyncStore();
const onJoinMeeting = (meetingId: string, params?: any) => {
    joinMeeting.onGetAll(() => MeetingRepository.onPostJoinMeeting(meetingId, params));
}

// 초대 코드로 모임 참여
const joinMeetingByCode = createAsyncStore();
const onJoinMeetingByCode = (inviteCode: string) => {
    return joinMeetingByCode.onGetAll(() => MeetingRepository.onPostJoinMeetingByCode(inviteCode));
}

// 모임 탈퇴
const leaveMeeting = createAsyncStore();
const onLeaveMeeting = (meetingId: string) => {
    leaveMeeting.onGetAll(() => MeetingRepository.onPostLeaveMeeting(meetingId));
}

// 모임 멤버 조회
const meetingMembers = createAsyncStore();
const onGetMeetingMembers = (meetingId: string) => {
    meetingMembers.onGetAll(() => MeetingRepository.onGetMeetingMembers(meetingId));
}

export const meetingStore = {
    meetingList,
    onGetMeetingList,

    meetingDetail,
    onGetMeetingDetail,

    createMeeting,
    onCreateMeeting,

    updateMeeting,
    onUpdateMeeting,

    deleteMeeting,
    onDeleteMeeting,

    inviteMeeting,
    onInviteMeeting,

    joinMeeting,
    onJoinMeeting,

    joinMeetingByCode,
    onJoinMeetingByCode,

    leaveMeeting,
    onLeaveMeeting,

    meetingMembers,
    onGetMeetingMembers
}
